import '../../Client/CollaboratorsClient/Collaborators.scss';

//import usePostRequest from '../../../hooks/usePostRequest';
import BlockOutlinedIcon from '@mui/icons-material/BlockOutlined';
import { Button } from '@mui/material';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import DialogValiderBackOffice from '../../../Components/Dialogs/DialogValiderBackOffice';
import { buttonStylesGreen } from '../../../Components/docsAdministrative/JsObjectStyles';
import { ChipRoleBackOffice, MaterialTableComponent, NomEmail } from '../../../Components/shared/ReusableSmallComponents';
import useAuth from '../../../hooks/useAuth';
import useAxiosPrivate from '../../../hooks/useAxiosPrivate';
import useUtilities from '../../../hooks/useUtilities';
import useWindowSize from '../../../hooks/useWindowSize';
import {statutBackOfficeEnum } from '../../../Utils/utils';
import EditerBackOffice from './EditerBackOffice';
import StatutBackOffice from './StatutBackOffice';

function CollaborateurHTH() {
    const { i18n } = useTranslation();
    const axiosPrivate = useAxiosPrivate();
    const {auth} = useAuth();
    const [dataCollaborateur, setDataCollaborateur] = useState([]);
    const { setBackdropOpen } = useUtilities();
    const [permission, setPermission] = useState('');
    const [open, setOpen] = useState(false);
    const {device}=useWindowSize();
    const navigate=useNavigate();
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'instant' });
    }, [navigate]); // Trigger when the pathname changes

    useEffect(() => {
        if(auth?.embeddedRoles){
            if (auth?.embeddedRoles?.Admin == 1 || auth?.embeddedRoles?.littleAdmin == 1) {
                setPermission('edit');
            }
        }
    }, [auth]);

    useEffect(() => {
        getMyCollaborators();
    }, []);

    const getMyCollaborators = async () => {
        setBackdropOpen(true);
        try {
            const response = await axiosPrivate.get('/admin/getMyHTHCollaborators'); //already has the same effect as /getInvitations
            let temp=[];

            response?.data?.forEach(element => {
                console.log('element',element,'isBlocked',element?.isBlocked);
                temp.push({
                    'id': element?._id,
                    'img': element?.backOfficeId?.persoData?.photo,
                    'statut': statutBackOfficeEnum(element?.isActive),
                    'role': element?.backOfficeId?.roles,
                    'tele': element?.backOfficeId?.persoData?.tele,
                    'nom': element?.backOfficeId?.persoData?.nom,
                    'prenom': element?.backOfficeId?.persoData?.prenom,
                    'email_': element?.email,
                    'nom_': element?.backOfficeId?.persoData?.nom + ',' + element?.backOfficeId?.persoData?.email,
                    'isBlocked': element?.isBlocked ?? false,
                });
            });
            console.log('temp temp',temp);
            setDataCollaborateur(temp);
            setBackdropOpen(false);
        }
        catch (error) {
            console.log(error);
            setBackdropOpen(false);
        }
    };

    const columns = [
        {
            field: 'nom',
            title: i18n.t('Nom'),
            render: rowData =>
                <NomEmail
                    nom={rowData?.nom}
                    prenom={rowData?.prenom}
                    email={rowData?.email_}
                />
        },
        {
            field: 'role',
            title: i18n.t('Rôle'),
            render: rowData => {
                return (
                    <>
                        <ChipRoleBackOffice rowSelected={rowData} />
                    </>

                );
            }
        },
        //170px valeur avant
        {
            field: 'statut',
            title: i18n.t('Statut'),
            render: rowData => {
                return (
                    <div style={{display: 'flex', flexDirection: 'raw',gap:'8px'}}>
                        <StatutBackOffice
                            width={'150px'}
                            rowSelected={rowData}
                            mode={permission}
                            //getMyCollaborators={getMyCollaborators}
                            defaultStatusCollab={rowData?.statut}
                        />
                        {rowData?.isBlocked &&
                            <BlockOutlinedIcon style={{color :'red',margin:'5px'}}/>
                        }
                    </div>

                );
            }
        },
        {
            field: 'edit',
            title: i18n.t('Options'),
            render: rowData => {
                return (
                    <EditerBackOffice
                        rowSelected={rowData}
                        getMyCollaborators={getMyCollaborators}
                    />

                );
            }
        }
    ];
    //const [selectedRow, setSelectedRow] = useState(null);

    return (
        <>
            <div
                style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', alignSelf: 'stretch', gap: '24px' }}
            >
                <div className='frame5Profile' > {i18n.t('Compte entreprise')} &gt;
                    <span style={{ color: 'rgba(39, 45, 60, 1)' }}>
                        {i18n.t('Collaborateurs High Tech Hires')} </span>
                </div>
                <div className='frame1Collaborators' >
                    <div className='frame2Collaborators' >
                        <h4
                            className='titlesociete'
                        > {i18n.t('Collaborateurs High Tech Hires')}
                        </h4>
                    </div>
                    {
                        permission == 'edit' &&
                        <div style={{ alignSelf: 'stretch', display: 'flex', justifyContent: 'flex-end',width:'100%' }}>
                            <Button
                                onClick={() => setOpen(true)}
                                variant='contained'
                                style={{...buttonStylesGreen(false),...{width:device=='desktop' ? 'auto':'100%'}}}
                            >
                                {i18n.t('Ajouter un collaborateur')}
                            </Button>
                        </div>
                    }
                    <MaterialTableComponent
                        columns={columns}
                        data={dataCollaborateur}
                        title={i18n.t('Collaborateurs')}
                        //onRowClick={(event, rowData) => {
                        //    setSelectedRow(rowData?.tableData.id);
                        //}}
                        //selectedRow={selectedRow}
                    />
                </div>
                {open &&
                <DialogValiderBackOffice
                    open={open}
                    setOpen={setOpen}
                    title={i18n.t('Ajouter un collaborateur')}
                    mode={'ajouter'}
                    getMyCollaborators={getMyCollaborators}
                />}
            </div>
        </>
    );
}

export default CollaborateurHTH;